<div id="dualaxis-bar"></div>